import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {Page} from 'src/app/shared/models/page.model';
import {UploadService} from '../../shared/services/upload.service';
import {Upload} from 'src/app/shared/models/upload.model';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'form-edit-sub-page',
    templateUrl: 'form-edit-sub-page.html'
})

export class FormEditSubPageComponent implements OnInit, OnDestroy {

    @Input() page: Page;

    uploads_new: Upload[] = [];

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService, private uploadService: UploadService) {
    }

    pageForm: FormGroup;

    ngOnInit() {
        this.initForm();

        this.uploadService.uploadSub
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            upload => {
                this.uploads_new.push(upload);
            }
        );
    }

    initForm() {
        this.pageForm = new FormGroup({
            'title': new FormControl(this.page.title),
            'url': new FormControl(this.page.url),
            'text_content': new FormControl(this.page.text_content)
        });
    }

    onUpdate() {
        const value = this.pageForm.value;
        const newPage = new Page(this.page.id, value.title, value.text_content, value.url, this.page.modified, this.page.created);
        this.dataStorageService.updatePage(newPage)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
                if (responseData['error']) {
                    console.log('updating sub page error');
                } else {
                    alert('sub page updated. ');
                    // location.reload();
                }
            });
    }

    onDelete() {
        if (confirm('Are you sure?')) {
            this.dataStorageService.deletePage(this.page.id)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(
                    responseData => {
                        if (responseData['error']) {
                            console.log('deleting sub page error');
                        } else {
                            alert('sub page deleted. ');
                            location.reload();
                        }
                    }
                );
        }
    }

    onUpload() {
        this.uploadService.uploadProcessEmitter.emit({'type': 'page', id: this.page.id});
    }

    onDeleteUpload(id: number, name: string) {
        this.dataStorageService.deleteUpload(id, name)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData['status'] === '200') {
                    console.log(responseData);
                    let index = 0;
                    if (this.page.upload.findIndex(upload => upload.id === id) !== null) {
                        index = this.page.upload.findIndex(upload => upload.id === id);
                        this.page.upload.splice(index, 1);
                    } else {
                        index = this.uploads_new.findIndex(upload => upload.id === id);
                        this.uploads_new.splice(index, 1);
                    }
                } else if (responseData['status'] === '405') {
                    console.log('not done');
                }
            }
        );
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
